import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Testimonials.css';

const Testimonials = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // Testimonials data
  const testimonialsList = [
    {
      id: 1,
      name: 'Somith Kumar',
      position: 'CEO, TechCorp',
      content: 'networkBuilder transformed our online presence completely. Their team delivered a website that not only looks great but also performs exceptionally well. The attention to detail and commitment to quality is unmatched.',
      image: 'https://randomuser.me/api/portraits/men/4.jpg'
    },
    {
      id: 2,
      name: 'Sarah saie',
      position: 'Marketing Director, Innovate Inc',
      content: 'The mobile application developed by networkBuilder helped us increase customer engagement by 40%. Their attention to detail and user experience is unmatched. We continue to work with them for all our digital needs.',
      image: 'https://randomuser.me/api/portraits/women/8.jpg'
    },
    {
      id: 3,
      name: 'Chetan Ray',
      position: 'Founder, StartUp Hub',
      content: 'Working with networkBuilder was a game-changer for our business. Their e-commerce solution increased our online sales by 65% within just three months. Their team is responsive, professional, and truly talented.',
      image: 'https://randomuser.me/api/portraits/men/65.jpg'
    },
    {
      id: 4,
      name: 'Shresha Shet',
      position: 'COO, FitLife Gym',
      content: 'The fitness app developed by networkBuilder has revolutionized how we engage with our members. The user interface is intuitive, and the features are exactly what we needed. Highly recommend their services!',
      image: 'https://randomuser.me/api/portraits/women/15.jpg'
    },
    {
      id: 5,
      name: 'David Park',
      position: 'Owner, Park Real Estate',
      content: 'Our real estate website has never looked better! networkBuilder understood our vision perfectly and delivered a platform that showcases our properties beautifully. The virtual tour feature they implemented is a client favorite.',
      image: 'https://randomuser.me/api/portraits/men/4.jpg'
    },
    {
      id: 6,
      name: 'Niranjan S kishan',
      position: 'Head of Digital, Education Plus',
      content: 'The learning management system created by networkBuilder has significantly improved our online education platform. Their technical expertise and understanding of user needs made the project a great success.',
      image: 'https://randomuser.me/api/portraits/women/26.jpg'
    }
  ];

  const [headerRef, headerInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [testimonialsRef, testimonialsInView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div className="testimonials-page">
      <section className="testimonials-header" ref={headerRef}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} md={10}>
              <motion.div
                initial="hidden"
                animate={headerInView ? "visible" : "hidden"}
                variants={fadeIn}
              >
                <h1 className="page-title">Client Testimonials</h1>
                <p className="lead">
                  Discover what our clients have to say about working with us and the results we've delivered for their businesses.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="testimonials-content section-padding" ref={testimonialsRef}>
        <Container>
          <motion.div
            initial="hidden"
            animate={testimonialsInView ? "visible" : "hidden"}
            variants={staggerContainer}
          >
            <Row>
              {testimonialsList.map((testimonial) => (
                <Col lg={4} md={6} className="mb-4" key={testimonial.id}>
                  <motion.div variants={fadeIn}>
                    <Card className="testimonial-card card-hover h-100">
                      <Card.Body className="p-4">
                        <div className="testimonial-content mb-4">
                          <p className="testimonial-text">"{testimonial.content}"</p>
                        </div>
                        <div className="testimonial-author d-flex align-items-center">
                          <img 
                            src={testimonial.image} 
                            alt={testimonial.name} 
                            className="testimonial-image"
                          />
                          <div className="testimonial-info">
                            <h5 className="mb-0">{testimonial.name}</h5>
                            <small className="text-muted">{testimonial.position}</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>
    </div>
  );
};

export default Testimonials; 